import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["videoAnalyticsData", "userActivityData"];
import { forwardRef, useRef } from 'react';
import CrehanaPlayerWithUserActivity from "./analytics/CrehanaPlayerWithUserActivity";
import CrehanaPlayerWithVideoAnalytics from "./analytics/CrehanaPlayerWithVideoAnalytics";
import CrehanaPlayerClass from "./CrehanaPlayerClass";
import { jsx as _jsx } from "react/jsx-runtime";
var CrehanaPlayerWrapper = function CrehanaPlayerWrapper(_ref, ref) {
  var videoAnalyticsData = _ref.videoAnalyticsData,
    userActivityData = _ref.userActivityData,
    crehanaPlayerProps = _objectWithoutProperties(_ref, _excluded);
  var playerRef = useRef(null);
  var playerProps = _objectSpread(_objectSpread({}, crehanaPlayerProps), {}, {
    ref: ref,
    playerRef: playerRef
  });
  if (videoAnalyticsData) {
    return userActivityData ? /*#__PURE__*/_jsx(CrehanaPlayerWithUserActivity, _objectSpread(_objectSpread({}, playerProps), {}, {
      videoAnalyticsData: videoAnalyticsData,
      userActivityData: userActivityData
    })) : /*#__PURE__*/_jsx(CrehanaPlayerWithVideoAnalytics, _objectSpread(_objectSpread({}, playerProps), {}, {
      videoAnalyticsData: videoAnalyticsData
    }));
  }
  if (userActivityData) {
    return /*#__PURE__*/_jsx(CrehanaPlayerWithUserActivity, _objectSpread(_objectSpread({}, playerProps), {}, {
      userActivityData: userActivityData
    }));
  }
  return /*#__PURE__*/_jsx(CrehanaPlayerClass, _objectSpread({}, playerProps));
};
export default /*#__PURE__*/forwardRef(CrehanaPlayerWrapper);